import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from './redux/store';
import App from './App';

import 'lib/src/_styles/generic.scss';
import './_styles/main.scss';

import { initApi } from 'lib/src/utils/api';
import { initWysiwyg } from 'lib/src/components/form/WYSIWYG';

import { API_URL, TINY_API_KEY } from './config';

initApi(API_URL);
initWysiwyg(TINY_API_KEY);

ReactDOM.render(
    <Router>
        <Provider store={store}>
            <App />
        </Provider>
    </Router>,
    document.getElementById('root'),
);
